import * as THREE from "three";
import {
  calculateBounds,
  calculateFurthestFrame,
  fromMM,
  toMM,
} from "./frameUtils";
import { COMPONENT_ALIGNMENT } from "../Constants";
export const DIM_AXES = { X: "x", Y: "y", Z: "z" };

export function makeDimensionable({
  id,
  type,
  position,
  size,
  framePosition,
  frameSize,
  unitBounds,
  visibleAxes = ["x", "y", "z"],
  alignment = 1,
  levels = [1, 1, 1],
  text = "",
  useFullFrame = true,
  ignoreHidden,
  alignments = null,
}) {
  return {
    id,
    type,
    boundingBox: { position, size },
    frameBoundingBox: {
      position: framePosition ?? position,
      size: frameSize ?? size,
    },
    unitBounds,
    visibleAxes,
    alignment,
    levels,
    text,
    useFullFrame,
    ignoreHidden,
    alignments,
  };
}

// export function calculateDimensions(
//   dimensionables,
//   dimSide = 1,
//   offsetHorizontal = 0,
//   offsetVertical = 0,
//   isTotal = false,
//   ignore_hidden = false,
// ) {
//   const results = [];

//   for (const item of dimensionables) {
//     let dimensionSide = dimSide;
//     let ignoreHidden = item.ignoreHidden ?? ignore_hidden;

//     let lengthAlignment = item.alignments
//       ? item.alignments.length == COMPONENT_ALIGNMENT.TOP
//         ? 1
//         : -1
//       : 1;

//     //let overrideHeightDimensionSideX = false;
//     let overrideWidthDimensionSideX = 0;
//     let overrideHeightDimensionSideX = 0;

//     // //override dimension side
//     // if (
//     //   item.dimensionSides !== null &&
//     //   item.dimensionSides !== undefined &&
//     //   false
//     // ) {
//     //   overrideWidthDimensionSideX = item.dimensionSides.width[0] !== 0;
//     //   overrideHeightDimensionSideX = item.dimensionSides.height[0] !== 0;
//     // }

//     if (item.type == "text") {
//       results.push({
//         id: item.id,
//         type: item.type,
//         text: item.text,
//         showLength: true,
//         positions: { length: item.boundingBox.position },
//       });
//       continue;
//     }

//     const { position, size } = item.boundingBox;
//     const { position: framePosition, size: frameSize } = item.frameBoundingBox;
//     const [w, h, d] = size;
//     const [x, y, z] = position;

//     const [fw, fh, fd] = frameSize;
//     const [fx, fy, fz] = framePosition;

//     const unitBounds = item.unitBounds;

//     const showX1 = item.visibleAxes.includes("x1");
//     const showX2 = item.visibleAxes.includes("x2");
//     const showX12 = item.visibleAxes.includes("x");

//     const showY1 = item.visibleAxes.includes("y1");
//     const showY2 = item.visibleAxes.includes("y2");
//     const showY12 = item.visibleAxes.includes("y");

//     const showZ1 = item.visibleAxes.includes("z1");
//     const showZ2 = item.visibleAxes.includes("z2");
//     const showZ12 = item.visibleAxes.includes("z");

//     if (dimensionSide == 0) {
//       if (showY1 || showY2) {
//         dimensionSide = showY2 ? 1 : -1;
//       } else if (showY12) {
//         dimensionSide = 1;
//       }

//       overrideHeightDimensionSideX = showY1 ? -1 : 1;
//       overrideWidthDimensionSideX = showZ1 ? -1 : 1;
//     }

//     const showX =
//       dimSide == 0 ||
//       (showX1 && dimensionSide == -1) ||
//       (showX2 && dimensionSide == 1) ||
//       showX12;
//     const showY =
//       (showY1 && dimensionSide == -1) ||
//       (showY2 && dimensionSide == 1) ||
//       showY12;
//     const showZ =
//       (showZ1 && dimensionSide == -1) ||
//       (showZ2 && dimensionSide == 1) ||
//       showZ12;

//     // const BASE_X = item.useFullFrame
//     //   ? unitBounds[
//     //       overrideHeightDimensionSideX
//     //         ? item.dimensionSides.height[0] == -1
//     //           ? 0
//     //           : 1
//     //         : dimensionSide == 1
//     //           ? 0
//     //           : 1
//     //     ]
//     //   : fx + (fw / 2) * dimensionSide * -1;
//     const BASE_X = item.useFullFrame
//       ? unitBounds[
//           overrideHeightDimensionSideX != 0
//             ? overrideHeightDimensionSideX == -1
//               ? 0
//               : 1
//             : dimensionSide == 1
//               ? 0
//               : 1
//         ]
//       : fx + (fw / 2) * dimensionSide * -1;
//     const BASE_Y = lengthAlignment * framePosition[1] + frameSize[1] / 2; //* lengthAlignment;
//     // const BASE_Z =
//     //   unitBounds[
//     //     overrideWidthDimensionSideX
//     //       ? item.dimensionSides.width[0] == -1
//     //         ? 0
//     //         : 1
//     //       : dimensionSide == 1
//     //         ? 1
//     //         : 0
//     //   ];
//     const BASE_Z =
//       unitBounds[
//         overrideWidthDimensionSideX != 0
//           ? overrideWidthDimensionSideX == -1
//             ? 0
//             : 1
//           : dimensionSide == 1
//             ? 1
//             : 0
//       ];

//     //const lengthPosition = [x, y + h / 2 + offsetV, z + d / 2];
//     const lengthPosition = [
//       x,
//       offsetVertical + BASE_Y + lengthAlignment * item.levels[0] * 0.25,
//       (fd / 2) * dimensionSide * -1,
//     ];
//     // const heightPosition = [
//     //   //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
//     //   offsetHorizontal +
//     //     BASE_X +
//     //     item.levels[1] *
//     //       0.25 *
//     //       (overrideHeightDimensionSideX
//     //         ? item.dimensionSides.height[0]
//     //         : dimensionSide * -1),
//     //   y,
//     //   (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
//     // ];
//     const heightPosition = [
//       //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
//       offsetHorizontal +
//         BASE_X +
//         item.levels[1] *
//           0.25 *
//           (overrideHeightDimensionSideX != 0
//             ? overrideHeightDimensionSideX
//             : dimensionSide * -1),
//       y,
//       (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
//     ];
//     // const widthPosition = [
//     //   BASE_Z +
//     //     item.levels[2] *
//     //       0.25 *
//     //       (overrideWidthDimensionSideX
//     //         ? item.dimensionSides.width[0]
//     //         : dimensionSide),
//     //   0,
//     //   z,
//     // ];
//     const widthPosition = [
//       BASE_Z +
//         item.levels[2] *
//           0.25 *
//           (overrideWidthDimensionSideX != 0
//             ? overrideWidthDimensionSideX
//             : dimensionSide),
//       0,
//       z,
//     ];

//     results.push({
//       id: item.id,
//       type: item.type,
//       length: w,
//       height: h,
//       width: d,
//       lengthMM: Math.round(toMM(w)),
//       heightMM: Math.round(toMM(h)),
//       widthMM: Math.round(toMM(d)),
//       showLength: showX || ignoreHidden,
//       showHeight: showY || ignoreHidden,
//       // showWidth:
//       //   (overrideWidthDimensionSideX &&
//       //     (item.dimensionSides.width[0] == dimensionSide || dimSide == 0)) ||
//       //   (!overrideWidthDimensionSideX && showZ),
//       showWidth: showZ,
//       positions: {
//         length: lengthPosition,
//         height: heightPosition,
//         width: widthPosition,
//       },
//       dimensionYAlignment: item.dimensionYAlignment,
//     });
//   }
//   return results;
// }

export function calculateDimensions(
  dimensionables,
  dimSide = 1,
  offsetHorizontal = 0,
  offsetVertical = 0,
  isTotal = false,
  ignore_hidden = false,
) {
  const results = [];

  for (const item of dimensionables) {
    let dimensionSide = dimSide;
    let ignoreHidden = item.ignoreHidden ?? ignore_hidden;

    let lengthAlignment = item.alignments
      ? item.alignments.length == COMPONENT_ALIGNMENT.TOP
        ? 1
        : -1
      : 1;

    //let overrideHeightDimensionSideX = false;
    let overrideWidthDimensionSideX = 0;
    let overrideHeightDimensionSideX = 0;

    // //override dimension side
    // if (
    //   item.dimensionSides !== null &&
    //   item.dimensionSides !== undefined &&
    //   false
    // ) {
    //   overrideWidthDimensionSideX = item.dimensionSides.width[0] !== 0;
    //   overrideHeightDimensionSideX = item.dimensionSides.height[0] !== 0;
    // }

    if (item.type == "text") {
      results.push({
        id: item.id,
        type: item.type,
        text: item.text,
        showLength: true,
        positions: { length: item.boundingBox.position },
      });
      continue;
    }

    const { position, size } = item.boundingBox;
    const { position: framePosition, size: frameSize } = item.frameBoundingBox;
    const [w, h, d] = size;
    const [x, y, z] = position;

    const [fw, fh, fd] = frameSize;
    const [fx, fy, fz] = framePosition;

    const unitBounds = item.unitBounds;

    const showX1 = item.visibleAxes.includes("x1");
    const showX2 = item.visibleAxes.includes("x2");
    const showX12 = item.visibleAxes.includes("x");

    const showY1 = item.visibleAxes.includes("y1");
    const showY2 = item.visibleAxes.includes("y2");
    const showY12 = item.visibleAxes.includes("y");

    const showZ1 = item.visibleAxes.includes("z1");
    const showZ2 = item.visibleAxes.includes("z2");
    const showZ12 = item.visibleAxes.includes("z");

    if (dimensionSide == 0) {
      if (showY1 || showY2) {
        dimensionSide = showY2 ? 1 : -1;
      } else if (showY12) {
        dimensionSide = 1;
      }

      overrideHeightDimensionSideX = showY1 ? -1 : 1;
      overrideWidthDimensionSideX = showZ1 ? -1 : 1;
    }

    const showX =
      dimSide == 0 ||
      (showX1 && dimensionSide == -1) ||
      (showX2 && dimensionSide == 1) ||
      showX12;
    const showY =
      (showY1 && dimensionSide == -1) ||
      (showY2 && dimensionSide == 1) ||
      showY12;
    const showZ =
      (showZ1 && dimensionSide == -1) ||
      (showZ2 && dimensionSide == 1) ||
      showZ12;

    // const BASE_X = item.useFullFrame
    //   ? unitBounds[
    //       overrideHeightDimensionSideX
    //         ? item.dimensionSides.height[0] == -1
    //           ? 0
    //           : 1
    //         : dimensionSide == 1
    //           ? 0
    //           : 1
    //     ]
    //   : fx + (fw / 2) * dimensionSide * -1;
    const BASE_X = item.useFullFrame
      ? unitBounds[
          overrideHeightDimensionSideX != 0
            ? overrideHeightDimensionSideX == -1
              ? 0
              : 1
            : dimensionSide == 1
              ? 0
              : 1
        ]
      : fx + (fw / 2) * dimensionSide * -1;
    const BASE_Y = lengthAlignment * framePosition[1] + frameSize[1] / 2; //* lengthAlignment;
    // const BASE_Z =
    //   unitBounds[
    //     overrideWidthDimensionSideX
    //       ? item.dimensionSides.width[0] == -1
    //         ? 0
    //         : 1
    //       : dimensionSide == 1
    //         ? 1
    //         : 0
    //   ];
    const BASE_Z =
      unitBounds[
        overrideWidthDimensionSideX != 0
          ? overrideWidthDimensionSideX == -1
            ? 0
            : 1
          : dimensionSide == 1
            ? 1
            : 0
      ];

    //const lengthPosition = [x, y + h / 2 + offsetV, z + d / 2];
    const lengthPosition = [
      x,
      offsetVertical + BASE_Y + lengthAlignment * item.levels[0] * 0.25,
      (fd / 2) * dimensionSide * -1,
    ];
    // const heightPosition = [
    //   //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
    //   offsetHorizontal +
    //     BASE_X +
    //     item.levels[1] *
    //       0.25 *
    //       (overrideHeightDimensionSideX
    //         ? item.dimensionSides.height[0]
    //         : dimensionSide * -1),
    //   y,
    //   (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
    // ];

    const heightDimensionsSide =  overrideHeightDimensionSideX != 0
            ? overrideHeightDimensionSideX
            : dimensionSide * -1;

    const heightScale = 
      item.levels[1] == 1 ? 0.4 : item.levels[1] == 2 ? 0.45 : 0.55;
    const heightPosition = [
      //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
      //  offsetHorizontal + BASE_X + item.levels[1] * 0.25 * (overrideHeightDimensionSideX != 0 ? overrideHeightDimensionSideX : dimensionSide * -1),
      offsetHorizontal +
        BASE_X +
        item.levels[1] *
          heightScale * heightDimensionsSide,
      y,
      (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
    ];
    // const widthPosition = [
    //   BASE_Z +
    //     item.levels[2] *
    //       0.25 *
    //       (overrideWidthDimensionSideX
    //         ? item.dimensionSides.width[0]
    //         : dimensionSide),
    //   0,
    //   z,
    // ];

    const widthScale =
      item.levels[1] == 1 ? 0.4 : item.levels[1] == 2 ? 0.45 : 0.55;

    const widthPosition = [
      BASE_Z +
        item.levels[2] *
          widthScale *
          (overrideWidthDimensionSideX != 0
            ? overrideWidthDimensionSideX
            : dimensionSide),
      0,
      z,
    ];

    results.push({
      id: item.id,
      type: item.type,
      length: w,
      height: h,
      width: d,
      lengthMM: Math.round(toMM(w)),
      heightMM: Math.round(toMM(h)),
      widthMM: Math.round(toMM(d)),
      showLength: showX || ignoreHidden,
      showHeight: showY || ignoreHidden,
      // showWidth:
      //   (overrideWidthDimensionSideX &&
      //     (item.dimensionSides.width[0] == dimensionSide || dimSide == 0)) ||
      //   (!overrideWidthDimensionSideX && showZ),
      showWidth: showZ,
      positions: {
        length: lengthPosition,
        height: heightPosition,
        width: widthPosition,
      },
      dimensionYAlignment: item.dimensionYAlignment,
      dimensionSide,
    });
  }
  return results;
}

export function collectDimensionables(
  frames,
  allFrames,
  frameThickness,
  view,
  baseframeHeight,
  isTotal,
  sectionViews,
  dimenionsionSide = 0,
) {
  const items = [];

  let x1 = calculateFurthestFrame(allFrames, -1, "length", frameThickness);
  let x2 = calculateFurthestFrame(allFrames, 1, "length", frameThickness);

  let isSections = frames.length > 1;
  let frame = frames[0];
  let frame2 = isSections ? frames[frames.length - 1] : frames[0];

  const hasLeftConnection =
    frame.connections?.filter(
      (c) => c.attachedTo != null && c.side == COMPONENT_ALIGNMENT.LEFT,
    ).length > 0;
  const hasRightConnection =
    frame2.connections?.filter(
      (c) => c.attachedTo != null && c.side == COMPONENT_ALIGNMENT.RIGHT,
    ).length > 0;
  const bounds = getFrameBounds(frames, frameThickness, baseframeHeight);

  if (isSections) {
    //unit height
    if (isTotal && baseframeHeight) {
      bounds.size[1] += baseframeHeight;
      bounds.pos[1] -= baseframeHeight / 2;
    }

    items.push(
      makeDimensionable({
        id: frame.id,
        visibleAxes:
          sectionViews && sectionViews[view]
            ? sectionViews[view].visibleAxes
            : ["x"],
        levels:
          sectionViews && sectionViews[view]
            ? sectionViews[view].levels
            : [1, 2, 1],
        alignments:
          sectionViews && sectionViews[view] && sectionViews[view].alignments
            ? sectionViews[view].alignments
            : null,
        // dimensionSides:
        //   sectionViews &&
        //   sectionViews[view] &&
        //   sectionViews[view].dimensionSides
        //     ? sectionViews[view].dimensionSides
        //     : null,
        // hasLeftConnection && hasRightConnection
        //   ? ["x"]
        //   : [
        //       "x",
        //       hasLeftConnection ? "y1" : hasRightConnection ? "y2" : "y",
        //       hasLeftConnection ? "z1" : hasRightConnection ? "z2" : "z",
        //     ],
        type: "frame",
        position: bounds.pos,
        size: bounds.size,
        unitBounds: [x1, x2],
      }),
    );

    return items;
  } else if (!frames[0].isExterior) {
    items.push(
      makeDimensionable({
        id: frame.id,
        visibleAxes: frames[0].dimension
          ? frames[0].dimension.visibleAxes
          : hasLeftConnection && hasRightConnection
            ? ["x"]
            : [
                "x",
                dimenionsionSide == 0
                  ? hasLeftConnection
                    ? "y2"
                    : hasRightConnection
                      ? "y1"
                      : "y"
                  : hasLeftConnection
                    ? "y1"
                    : hasRightConnection
                      ? "y2"
                      : "y",
                hasLeftConnection ? "z2" : hasRightConnection ? "z1" : "z",
              ],
        type: "frame",
        position: bounds.pos,
        size: bounds.size,
        unitBounds: [x1, x2],
      }),
    );
  }

  for (const frame of frames) {
    const bounds = getFrameBounds([frame], frameThickness);
    if (frame.innerComponents) {
      for (const comp of frame.innerComponents) {
        const pos = comp.boundingBox?.position ?? [0, 0, 0];
        const size = comp.boundingBox?.size ?? [1, 1, 1];
        const views = comp.views;
        items.push(
          makeDimensionable({
            id: comp.id,
            type: comp.type,
            position: [
              bounds.pos[0] + pos[0],
              bounds.pos[1] + pos[1],
              bounds.pos[2] + pos[2],
            ],
            size,
            framePosition: bounds.pos,
            frameSize: bounds.size,
            unitBounds: [x1, x2],
            visibleAxes: views && views[view] ? views[view].visibleAxes : [],
            levels: views && views[view] ? views[view].levels : [],
            alignments:
              views && views[view] && views[view].alignments
                ? views[view].alignments
                : null,
            text: comp.text,
            useFullFrame: comp.useFullFrame,
            ignoreHidden: comp.ignoreHidden,
          }),
        );
      }
    }
  }

  return items;
}

function getFrameBounds(frames, frameThickness) {
  const _boxPos = new THREE.Vector3();
  const _boxSize = new THREE.Vector3();
  calculateBounds(frames, _boxPos, _boxSize, frameThickness);
  return {
    pos: [_boxPos.x, _boxPos.y, _boxPos.z],
    size: [_boxSize.x, _boxSize.y, _boxSize.z],
  };
}
